import { useEffect, useMemo, useState } from 'react';
import { PaymentContext } from './PaymentContext';
import { GenerateDefaultPaymentStatus, IPaymentContextProvider } from './PaymentContext.types';

export const PaymentContextProvider = (props: IPaymentContextProvider) => {
    const { children } = props;

    const [attempted, setAttempted] = useState(false);
    const [status, setStatus] = useState(GenerateDefaultPaymentStatus());
    const [due, setDue] = useState(0);
    const [idiCartId, setIdiCartId] = useState(0);

    useEffect(() => {
        const sessionAttempted = window.sessionStorage.getItem('paymentAttempted');
        const paymentStatus = window.sessionStorage.getItem('paymentStatus');
        const due = window.sessionStorage.getItem('due');
        const idiCartId = window.sessionStorage.getItem('idiCartId');

        if (sessionAttempted) setAttempted(true);
        if (paymentStatus) setStatus(JSON.parse(paymentStatus));
        if (due) setDue(Number(due));
        if (idiCartId) setIdiCartId(Number(idiCartId));
    }, []);

    const value = useMemo(() => {
        return {
            attempted,
            setAttempted,
            status,
            setStatus,
            due,
            setDue,
            idiCartId,
            setIdiCartId
        };
    }, [attempted, setAttempted, status, setStatus, due, setDue, idiCartId, setIdiCartId]);

    return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>;
};

export default PaymentContextProvider;
